import { faTimesCircle } from '@fortawesome/sharp-regular-svg-icons';
import FocusLock from 'react-focus-lock';
import { useTranslation } from 'react-i18next';

import { Button } from '../components/button/Button';
import useKeyboardAction from '../hooks/useKeyboardAction';

export function ChartModal({ title, onClose, data }) {
  const { t } = useTranslation();

  useKeyboardAction(() => {
    onClose();
  }, 'Escape');

  return (
    <FocusLock returnFocus>
      <div
        className="popup-overlay fs-exclude"
        role="dialog"
        aria-modal="true"
        aria-labelledby="chart-modal-title"
      >
        <span className="visuallyHidden">{t('modal.chart.description', { title })}</span>
        <div className="popup-container  chart-modal">
          <Button
            ariaLabel={t('modal.close')}
            className="close-icon"
            icon={{ faIconDefinition: faTimesCircle }}
            onClick={onClose}
            variant="icon-only"
          />
          <h2 className="popup-title" id="chart-modal-title">
            {title}
          </h2>
          <div className="popup-body ">
            <p>{t('chart.modal.text1')}</p>
            <p>{t('chart.modal.text2')}</p>
            <table className="chart-table">
              <thead>
                <tr>
                  <th className="chart-table-cell">{t('chart.modal.date')}</th>
                  <th className="chart-table-cell">{t('chart.modal.value')}</th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data
                    .filter((item) => item.value !== null && item.value !== 'No data')
                    .map((item, index) => (
                      <tr key={index}>
                        <td className="chart-table-cell">{item.date}</td>
                        <td className="chart-table-cell">{item.value}</td>
                      </tr>
                    ))}
              </tbody>
            </table>
            <button className="chart-close-button" onClick={onClose}>
              {t('chart.modal.close')}
            </button>
          </div>
        </div>
      </div>
    </FocusLock>
  );
}
